module.exports = "<div class=\"ui active dimmer\">\n  <div class=\"ui huge inverted text loader\">Đang xử lý</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/shared/callback/callback.component.html
// module id = ../../../../../src/app/shared/callback/callback.component.html
// module chunks = main